<div class="toolbar">
  <div class="logo" (click)="onLogoClick()">
    <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle style="fill:none;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" cx="75" cy="75" r="50"/>
      <circle style="fill-opacity:1;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" cx="75" cy="75" r="20"/>
      <circle style="fill-opacity:1;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" cx="75" cy="25" r="10"/>
    </svg>
    <h1>{{ 'APP_TITLE' | translate }}</h1>
  </div>

  <mat-form-field appearance="outline" class="search-field" (click)="openSearchPanel()">
    <mat-icon matPrefix class="prefix" fontIcon="rocket_launch" />
    <input matInput
      [(ngModel)]="search"
      [placeholder]="translate.get('Navigate') | async"
      autocomplete="off">
      @if (showSearchPanel && search && search !== '') {
        <button mat-icon-button
          aria-label="clear search"
          matSuffix
          (click)="search = ''">
          <mat-icon fontIcon="close" />
        </button>
      }
    </mat-form-field>

    @if (showSearchPanel) {
      <button
        mat-icon-button
        aria-label="close"
        class="close-button"
        (click)="onCloseClick()">
        <mat-icon fontIcon="close" />
      </button>
    }
    @if (!showSearchPanel) {
      <div [matMenuTriggerFor]="menu">
        <button mat-icon-button class="menu-button" aria-label="menu">
          <mat-icon fontIcon="more_vert" />
        </button>
      </div>
    }
    <mat-menu #menu="matMenu" class="toolbar-menu">
      <button mat-menu-item (click)="openSettings()">{{ 'Settings' | translate }}</button>
      <button mat-menu-item (click)="openContact()">{{ 'Contact' | translate }}</button>
      <button mat-menu-item (click)="openAbout()">{{ 'About' | translate }}</button>
      <button mat-menu-item (click)="openLegals()">{{ 'Legals' | translate }}</button>
    </mat-menu>
  </div>

  <div class="content">
    <router-outlet />

    @if (showSearchPanel) {
      <app-search-panel animate.enter="enter-search-panel" animate.leave="leave-search-panel" [search]="search" />
    }
  </div>
